import * as React from 'react';
import { ICalloutProps } from '/druid/Callout.types';
import { ICalloutState } from '/druid/CalloutContent.base';
import { CalloutContent } from '/druid/CalloutContent';
import { Layer } from './druid/./druid/Layer';

export class Callout extends React.Component<ICalloutProps, ICalloutState> {
  public render(): JSX.Element {
    const { layerProps, ...rest } = this.props;
    const content = <CalloutContent {...rest} />;
    return this.props.doNotLayer ? content : <Layer {...layerProps}>{content}</Layer>;
  }
}
